<template>
  <div class="home">
    <top-navigation ref="topNav"
                    navBg="#fff"
                    :isHome="false"></top-navigation>
    <div style="height:75px"></div>
    <div class="box">
      <div class="currency_box">
        <div class="kc_list font24"
             @click="toTechList">数字产品列表</div>
        <div class="top_nav_list">
          <div class="top_nav_item">{{title}}</div>
        </div>
      </div>
    </div>
    <div>
      <div class="curriculum_top_box">
        <div class="currency_box from_flex">
          <!-- 课程 -->
          <div class="kc">
            <el-carousel width="500"
                         :autoplay="false"
                         heigt="300">
              <el-carousel-item v-for="item in topDetailUrls"
                                :key="item">
                <el-image style="width:500px;height:300px;border-radius: 10px;"
                          :src="item"></el-image>
              </el-carousel-item>
            </el-carousel>
          </div>
          <div class="form_content">
            <!-- <div>{{ itemData }}</div> -->
            <div class="curriculum_title font24 flexStart">
              <div style="flex: 1;">
                {{itemData.name}}
              </div>
              <el-button type="danger"
                         style="margin-right: 20px;width: 200px;"
                         @click="showModal">立即购买</el-button>
            </div>
            <div class="curriculum_fu_title font14">{{itemData.shortIntro}}</div>
            <!-- <div class="curriculum_fu_title font20"
                 style="color: red;font-weight: bold;">¥{{itemData.price}}</div> -->

            <div class="flexStart"
                 style="flex-wrap: wrap;margin:10px 0;">
              <div :class="itemData.id ==item.id?'active spec_item':'spec_item'"
                   @click="specItemClick(item)"
                   v-for="(item,index) in specList"
                   :key="index+'index'">
                <div class="name">{{ item.name }}</div>
                <div class="flexStart">
                  <div class="price"
                       style="margin:5px 0;">¥{{ item.price }}</div>
                  <s>¥{{ item.scribingPrice }}</s>
                </div>
                <!-- <div>{{ item.shortIntro }}</div> -->
              </div>
            </div>
            <!-- <div class="curriculum_price font18 mainColor"> <span>价格</span> ￥{{courseData.price}} </div>
            <div class="curriculum_label font14"
                 v-if="courseData.ifVipFree == 1">零售视界个人会员免费学习</div> -->
            <!-- <div class="curriculum_ul">
              <div v-if="courseData.totalSpan && courseData.totalSpan>0"
                   class="curriculum_li">
                <i class="el-icon-time"></i>
                {{convertTime(courseData.totalSpan)}}
              </div>
              <div class="curriculum_li">
                <div v-if="courseData.studyCount && courseData.studyCount>0">
                  <i class="el-icon-user"></i>
                  学习人数:{{courseData.studyCount}}
                </div>
              </div>
              <div class="curriculum_li">
                <i class="el-icon-set-up"></i>
                课后绑定考试
              </div>
              <div class="curriculum_li">
                <i class="el-icon-paperclip"></i>
                配套思维导图
              </div>
            </div> -->

          </div>
        </div>
        <div class="currency_boxs"
             style="margin-top: 40px;">
          <div class="flexStart"
               style="margin-bottom: 20px;">产品详情</div>
          <div class="detailInfo" v-html="itemData.detailInfo"></div>
        </div>
      </div>
    </div>

    <pay-modal ref="payModal"
               @wechatPaySuccess="wechatPaySuccess"
               @orderStatusClose="orderStatusClose"
               v-if="payDialog"></pay-modal>
  </div>
</template>
<script>
import {
  techProductDetail
} from '@/api/api.js';
import payModal from './payModal.vue';
export default {
  components: { payModal },
  data () {
    return {
      title: null,
      payDialog: false,
      techProductInfo: {},
      itemData: {},
      topDetailUrls: null
    }
  },
  created () {
    this.getDetail('init');
  },
  methods: {
    wechatPaySuccess () {
      console.log("支付成功");
    },
    orderStatusClose () {
      console.log("订单关闭");
    },
    showModal () {
      console.log(this.itemData)
      this.payDialog = true;
      this.$nextTick(() => {
        this.$refs.payModal.init(this.itemData)
      })

    },
    specItemClick (item) {
      this.itemData = item;
    },
    toTechList () {
      this.$router.push('/TechProduct')
    },
    getDetail (type) {
      console.log(this.$route)
      this.id = this.$route.query.id;
      this.title = this.$route.query.name || '';
      techProductDetail(this.id).then(res => {
        console.log(res)
        if (res.code <= 200) {
          let { specList, topDetailUrls } = res.data;
          if (specList && specList.length != 0) {
            const regex = new RegExp('<img', 'gi');
            const regexs = new RegExp('<video', 'gi');
            const regexss = new RegExp('<iframe', 'gi');
            specList.forEach((item) => {
              item.detailInfo = item.detailInfo.replace(regex, `<img style="width: 100%;"`);
              item.detailInfo = item.detailInfo.replace(regexs,	'<video style="width:100%;heihgt:auto; object-fit: fill;"');
              item.detailInfo = item.detailInfo.replace(regexss,	'<iframe style="width:100%;heihgt:500px;object-fit: fill;"');
           
            })
            this.specList = specList;
          }
          if (topDetailUrls) {
            this.topDetailUrls = topDetailUrls.split(',');
            console.log(this.topDetailUrls)
          }
          if (specList && type == 'init') {
            let specId = this.$route.query.specId
            if(specId){
              this.specList.forEach((x)=>{
                if(x.id == specId){
                  this.itemData  = x;
                }
              })
            }else{
              this.itemData = specList[0]
            }
          }
        }
      })
    }
  }
}
</script>
<style>
iframe{
  width:100%;
  height: 700px !important;
}
iframe video{
  width:100% !important;
  height:auto !important;
  object-fit: fill !important;
}
</style>
<style lang="less" scoped>
::-webkit-scrollbar {
  width: 0 !important;
  display: none !important;
}
.detailInfo{
  width:100%;
  overflow:hidden;
}
.home {
  position: relative;
  background-color: #fff;
  min-height: 100vh;
  // padding-top: 30px;
  .box {
    min-width: 1200px;
    padding: 20px 0;
    box-sizing: border-box;
    background-color: #de1f26;
    color: #fff;
    .kc_list {
      font-weight: bold;
      padding-right: 18px;
      border-right: 1px solid #fff;
      cursor: pointer;
    }
    .top_nav_list {
      flex: 1;
      display: flex;
      padding-left: 30px;
      justify-content: flex-start;
      .top_nav_item {
        margin-right: 15px;
      }
    }
  }
  .curriculum_top_box {
    // margin: 20px 0 0 0;
    min-width: 1200px;
    background-color: #fff;
    // height: 500px;
    padding: 50px 0 40px 0;
    box-sizing: border-box;
    .from_flex {
      display: flex;
      align-items: flex-start;
      height: 100%;
      .kc {
        width: 500px;
        overflow-y: hidden;
        // height: 250px;
      }
      .form_content {
        flex: 1;
        margin-left: 24px;
        .spec_item {
          // display: flex;
          width: 44%;
          font-size: 14px;
          margin-right: 10px;
          // text-align: center;
          padding: 20px 10px;
          // font-size: 16px;
          border: 2px solid #e5e5e5;
          background-color: #fff;
          color: #000;
          border-radius: 10px;
          margin-bottom: 10px;
          cursor: pointer;
          .name {
            font-weight: bold;
            font-size: 16px;
          }
          .price {
            font-size: 14px;
            color: red;
            font-weight: bold;
          }
          s {
            font-size: 12px;
            color: #999;
            margin-left: 10px;
          }
        }
        .active {
          border: 2px solid #dfb349;
          background: #fff8e6;
          color: #000;
        }
        .curriculum_title {
          color: #333;
        }
        .curriculum_fu_title {
          color: #666;
          margin-top: 10px;
        }
        .curriculum_price {
          font-family: 'bb';
        }
        .curriculum_label {
          margin-left: 5px;
          display: inline-block;
          padding: 3px 12px;
          box-sizing: border-box;
          background-color: #ffeced;
          border-radius: 16px;
        }
        .curriculum_ul {
          display: flex;
          color: #666;
          .curriculum_li {
            margin-right: 20px;
          }
        }
      }
    }
  }
  .curriculum_details {
    margin-top: 20px;
    min-width: 1200px;
    background-color: #fff;
    .detailedIntroduction {
      width: 100%;
      img {
        width: 100%;
      }
    }
    .kcItem {
      margin: 2px 0;
      // margin-bottom: 10px;
      .bottomItem:hover {
        background-color: #ffeced;
        cursor: pointer;
      }
      .bottomItem {
        padding: 10px 20px;
        box-sizing: border-box;
        color: #666666;
        .sk {
          color: #de1f26;
          font-size: 14px;
        }
        .left {
          .label {
            display: inline-block;
            padding: 4px 10px;
            box-sizing: border-box;
            background-color: #de1f26;
            color: #fff;
          }
        }
        .right {
          .r {
            padding: 0 10px;
            border-right: 1px solid #e5e5e5;
          }
        }
      }
      .top {
        background-color: #f6f6f6;
        padding: 10px 20px;
        box-sizing: border-box;
        .left {
          font-weight: bold;
          color: #333;
        }
      }
    }
  }
}
</style>